import axios from 'axios';
import {typesOrder} from '../svtypes/ord'
import { SV_SOJ_ORCMOCK_ADDRESS } from '../../constants';

const _ = require('lodash')

const headers = {'Content-Type': 'application/json'}
function lowercaseKeys(obj) {
    return Object.keys(obj).reduce((accumulator, key) => {
      accumulator[key.toLowerCase()] = obj[key];
      return accumulator;
    }, {});
  }

  

export function ordAndImagesSV_old(custId){
    return dispatch => {
        dispatch(getOrdSearchBegin())
       
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuilaCanQuery`
        let sojPostRq_old = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }

          let sojPostRq = {
            "query": {
                "multi_match": {
                    "fields": [
                        "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
                    ],
                    "query": "WorldMark Long Beach",
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range" : {
                    "STARTDATE": {
                        "gte" : "2023-10-24",
                        "lt" :  "2023-11-27",
                        "time_zone": "+01:00"
                    }
                }
              }
        }
//we will hard code csutIs6 an have listView reservation fos custId =6  and then cahnge the view
        let custReservationListPostRq = {
            "docId":["6"],
            "hsetname":"HotelInvDB"
        }
       
        if(custId > 0){
            custReservationListPostRq.docId = []
            custReservationListPostRq.docId.push("" +custId)
        }
        const urlCustOrderWithItems = `${SV_SOJ_ORCMOCK_ADDRESS}/myreervationssv/svlist`
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
       /*
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        */
        /*
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])

        */
        axios.all([
            axios.post(urlCustOrderWithItems, custReservationListPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
                let rFob = rFobAx.data

                let r = rFob.svo
                let prices = rFob.dbo
                let a_price = prices[0]
                let prices_map = {}
                prices.forEach(p => {
                    let k =p.spaceKey
                    prices_map[k] = p
                });
               

                const comData = { my_data: []}
                let item , ob, upperOb

                if(r.hits.hits.length>0){
                    const ar = r.hits.hits
                   
                    
                    ar.forEach(a_rec => {
                        item = {}
                       
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)

                        let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                       ob['sv_rating'] = sv_rating
                       ob['sv_availability_of_rooms'] = 8
                       _.merge(ob, a_price)
                        
    
    
                        comData.my_data.push(ob)
                    });
                    if( r2.data && r2.data[0]){
                        comData.my_images = r2.data[0]
                    }
                   console.log('sv****merged data star')
                   console.log(comData)
                   console.log('sv****merged data end')
                    dispatch(getOrdSearchMultiplceCallsSuccess(comData))
                }else if(r.data && r.data.length > 0){

                    const ardb = r.data
                   
                    ardb.forEach(a_rec => {
                        item = {}
                       
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)
                        comData.my_data.push(ob)
                    });
                    dispatch(getOrdSearchSuccess(comData))
                }else {
                    const comData = { items: []}
                    dispatch(getOrdSearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getOrdSearchError(e))}
           
        )
    }
}


export function getSoDetails(nameQParam){
    return dispatch => {
        dispatch(getOrdSearchBegin())
       
        const url = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
        const body = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }
          
        axios.post(url, body, {headers:headers})
        .then(
            r => {
                if(r.data.hits.hits.length>0){
                    const ar = r.data.hits.hits
                    const comData = { my_data: []}
                    let item , ob
                    ar.forEach(a_rec => {
                        item = {}
                        ob = a_rec['_source']
                        let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'

                       }else if(rating == 1){

                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){

                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {

                        sv_rating = 'Excellent'
                       }
                       ob['sv_rating'] = sv_rating
                       ob['sv_availability_of_rooms'] = 8
                        /*
                        item['sojourncode']= ob['sojourncode']
                        item['vernacularcode']= ob['vernacularcode']
                        item['sojourn_name']= ob['sojourn_name']
                         comData.my_data.push(item)
                        */


                        comData.my_data.push(ob)
                    });

                   
                    dispatch(getOrdSearchSuccess(comData))
                }
                else {
                    const comData = { items: []}
                    dispatch(getOrdSearchSuccess(comData))
                }
            }
        ).catch(
            e=>dispatch(getOrdSearchError(e))
        )
    }
}


export const getOrdSearchSuccess = (data) => dispatch => {
    dispatch({
        type: typesOrder.GET_ORDER_SUCCESS,
        payload: data
    })
}

export const getOrdSearchMultiplceCallsSuccess = (data) => dispatch => {
    dispatch({
        type: typesOrder.GET_ORDER_SUCCESS,
        payload: data
    })
}

export const getOrdSearchBegin = () => dispatch => {
    dispatch({
        type:typesOrder.GET_ORDER_BEGIN
        
    })
}

export const getOrdSearchError = (e) =>dispatch => {
    dispatch({
        type:typesOrder.GET_ORDER_ERROR,
        payload:e
    })
}



export function ordAndImagesSV(custId,hdr, relUrl){
    return dispatch => {
        dispatch(getOrdSearchBegin())
       
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
        const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuilaCanQuery`
        let sojPostRq_old = {
            "query": {
              "match": {
                "sojourn_name": {
                  "query": "mancreek",
                  "operator": "and"
                }
              }
            }
          }

          let sojPostRq = {
            "query": {
                "multi_match": {
                    "fields": [
                        "STATE",  "ADDRESS_LINE1", "COUNTRY_NAME", "SOJOURN_NAME"
                    ],
                    "query": "WorldMark Long Beach",
                    "operator": "or",
                    "fuzziness": "AUTO"
                }
            },
            "post_filter": {
                "range" : {
                    "STARTDATE": {
                        "gte" : "2023-10-24",
                        "lt" :  "2023-11-27",
                        "time_zone": "+01:00"
                    }
                }
              }
        }
//we will hard code csutIs6 an have listView reservation fos custId =6  and then cahnge the view
        let custReservationListPostRq = {
            "docId":["6"],
            "hsetname":"HotelInvDB"
        }
       
        if(custId > 0){
            custReservationListPostRq.docId = []
            custReservationListPostRq.docId.push("" +custId)
        }
        const urlCustOrderWithItems = `${SV_SOJ_ORCMOCK_ADDRESS}/myreervationssv/svlistfinal`
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
       /*
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        */
        /*
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])

        */
        const svurl = relUrl ? `${SV_SOJ_ORCMOCK_ADDRESS}/${relUrl}` :urlCustOrderWithItems
        const svhdr = hdr ? hdr: headers 
      

        axios.all([
            axios.post(svurl, custReservationListPostRq, {headers:svhdr}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
                let rFob = rFobAx.data

                let r = rFob.svo
                let prices = rFob.dbo
                //let a_price = prices[0]
                let a_price = null;
                let prices_map = {}
                prices.forEach(p => {
                    let k =p.spaceKey
                    prices_map[k] = p
                });
               console.log('%%%%%%%%%%%Price map')
               console.log(prices_map)

                const comData = { my_data: []}
                let item , ob, upperOb

                if(r.hits.hits.length>0){
                    const ar = r.hits.hits
                   
                    
                    ar.forEach(a_rec => {
                        item = {}
                       
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)

                        let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                        let sv_rating = 'Excellent'
                       if(rating == 0){
                        sv_rating = 'Excellent'
    
                       }else if(rating == 1){
    
                        sv_rating = 'Poor'
                    }else if(rating == 2){
                        sv_rating = 'Fair'
                    }else if(rating == 3){
    
                        sv_rating = 'Recommend'
                    }else if(rating == 4){
                        sv_rating = 'Favorite'
                    }else if(rating == 5){
                        sv_rating = 'Excellent'
                    }else {
    
                        sv_rating = 'Excellent'
                       }
                       ob['sv_rating'] = sv_rating
                       ob['sv_availability_of_rooms'] = 8
                       let k_sv = ob['spacekey']
                       a_price = prices_map[k_sv]
                       console.log('a_price',a_price)
                       ob = _.merge(ob, a_price)
                       console.log('afterMerge ob a_price' , ob, a_price)
                      
                        
    
    
                        comData.my_data.push(ob)
                    });
                    if( r2.data && r2.data[0]){
                        comData.my_images = r2.data[0]
                    }
                   console.log('sv****merged data star')
                   console.log(comData)
                   console.log('sv****merged data end')
                    dispatch(getOrdSearchMultiplceCallsSuccess(comData))
                }else if(r.data && r.data.length > 0){

                    const ardb = r.data
                   
                    ardb.forEach(a_rec => {
                        item = {}
                       
                        upperOb = a_rec['_source']
                        ob =lowercaseKeys(upperOb)
                        comData.my_data.push(ob)
                    });
                    dispatch(getOrdSearchSuccess(comData))
                }else {
                    const comData = { items: []}
                    dispatch(getOrdSearchSuccess(comData))
                }
                  
                   
                }
            )
        ).catch(
            e=>{dispatch(getOrdSearchError(e))}
           
        )
    }
}

export function ordAndImagesSVSecure(custId, svtv){
    return dispatch => {
        dispatch(getOrdSearchBegin())
       
        //const urlSoj = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/svuila`
       
//we will hard code csutIs6 an have listView reservation fos custId =6  and then cahnge the view
        let custReservationListPostRq = {
            "docId":["6"],
            "hsetname":"HotelInvDB"
        }
       
        if(custId > 0){
            custReservationListPostRq.docId = []
            custReservationListPostRq.docId.push("" +custId)
            //custReservationListPostRq.docId.push("" +87)
        }
        const urlCustOrderWithItemsSecure = `${SV_SOJ_ORCMOCK_ADDRESS}/myreervationssv/svlistfinalSecure`
        const urlSojImages = `${SV_SOJ_ORCMOCK_ADDRESS}/essearch/images`
       /*
        if(sojPostRqFromPage){
            sojPostRq = sojPostRqFromPage
        }
        */
        /*
        axios.all([
            axios.post(urlSoj, sojPostRq, {headers:headers}),
            axios.get(urlSojImages, {headers:headers})
        ])

        */
        const authtoken = `Bearer ${svtv}`
        const svheaders = { 'Authorization': authtoken,
        'Content-Type': 'application/json' };
     
      

        axios.all([
            axios.post(urlCustOrderWithItemsSecure, custReservationListPostRq, {headers:svheaders}),
            axios.get(urlSojImages, {headers:headers})
        ])
        .then(
            axios.spread((rFobAx,r2)=>{
                let rFob = rFobAx.data
                if( !(rFob.dbo) ){
                    let eeb = {}
                       
                    
                    eeb.errob = {
                        "timestamp": "2024-08-23T02:27:18.038+0000",
                        "status": 500,
                        "error": "Internal Server Error",
                        "message": "500 null",
                        "path": "/accountclient/svaddressDetailPost"
                    }
                    dispatch(getOrdSearchError(eeb))
                }else{
                     //sstart rFobAx

                        let r = rFob.svo
                        let prices = rFob.dbo
                        //let a_price = prices[0]
                        let a_price = null;
                        let prices_map = {}
                        prices.forEach(p => {
                            let k =p.spaceKey
                            prices_map[k] = p
                        });
                    console.log('%%%%%%%%%%%Price map')
                    console.log(prices_map)

                        const comData = { my_data: []}
                        let item , ob, upperOb

                        if(r.hits.hits.length>0){
                            const ar = r.hits.hits
                        
                            
                            ar.forEach(a_rec => {
                                item = {}
                            
                                upperOb = a_rec['_source']
                                ob =lowercaseKeys(upperOb)

                                let rating = (ob['svr_vep_rating']? ob['svr_vep_rating'] : 0 )
                                let sv_rating = 'Excellent'
                            if(rating == 0){
                                sv_rating = 'Excellent'
            
                            }else if(rating == 1){
            
                                sv_rating = 'Poor'
                            }else if(rating == 2){
                                sv_rating = 'Fair'
                            }else if(rating == 3){
            
                                sv_rating = 'Recommend'
                            }else if(rating == 4){
                                sv_rating = 'Favorite'
                            }else if(rating == 5){
                                sv_rating = 'Excellent'
                            }else {
            
                                sv_rating = 'Excellent'
                            }
                            ob['sv_rating'] = sv_rating
                            ob['sv_availability_of_rooms'] = 8
                            let k_sv = ob['spacekey']
                            a_price = prices_map[k_sv]
                            console.log('a_price',a_price)
                            ob = _.merge(ob, a_price)
                            console.log('afterMerge ob a_price' , ob, a_price)
                            
                                
            
            
                                comData.my_data.push(ob)
                            });
                            if( r2.data && r2.data[0]){
                                comData.my_images = r2.data[0]
                            }
                        console.log('sv****merged data star')
                        console.log(comData)
                        console.log('sv****merged data end')
                            dispatch(getOrdSearchMultiplceCallsSuccess(comData))
                        }else if(r.data && r.data.length > 0){

                            const ardb = r.data
                        
                            ardb.forEach(a_rec => {
                                item = {}
                            
                                upperOb = a_rec['_source']
                                ob =lowercaseKeys(upperOb)
                                comData.my_data.push(ob)
                            });
                            dispatch(getOrdSearchSuccess(comData))
                        }else {
                            const comData = { items: []}
                            dispatch(getOrdSearchSuccess(comData))
                        }
                        
                   //svend rFobAx
                }

                
                }
            )
        ).catch(
            e=>{dispatch(getOrdSearchError(e))}
           
        )
    }
}
